import React from 'react'
import { Switch, Route } from 'react-router-dom'

import { ErrorBoundary } from '@scoir/error-reporter'

import RealtimeMessagingProvider from 'components/RealtimeMessagingProvider'

import AuthRoutes from './AuthRoutes'
import UserStartup from './UserStartup'
import UserTrackingStartup from './UserTrackingStartup'
import ReactRouterProvider from 'components/ReactRouterProvider'

export const AppStartup = () => {
  return (
    <UserStartup>
      <ReactRouterProvider>
        <UserTrackingStartup>
          <RealtimeMessagingProvider>
            <ErrorBoundary>
              <Switch>
                <Route render={(props) => <AuthRoutes {...props} />} />
              </Switch>
            </ErrorBoundary>
          </RealtimeMessagingProvider>
        </UserTrackingStartup>
      </ReactRouterProvider>
    </UserStartup>
  )
}

export default AppStartup
